import React, { useState, useEffect } from "react";
import { BiAbacus } from "react-icons/bi";
import { BiMenu } from "react-icons/bi";
import { BiCodeAlt } from "react-icons/bi";
import { GiBarbedStar } from "react-icons/gi";
import { FaSuitcase } from "react-icons/fa";
import { GiAchievement } from "react-icons/gi";
import { BsPersonLinesFill } from "react-icons/bs";
import { MdContactPhone } from "react-icons/md";
import { GiCloudDownload } from "react-icons/gi";
import { BiLeftArrow } from "react-icons/bi";
import { IoIosArrowDown } from "react-icons/io";
import model from './model.png';

const Home = () => {
    const [show, setShow] = useState({ val: "", flag: false });
    const [details, setdetails] = useState({ data: "", flag_msg: false })
    const [blink, setblink] = useState(true)

    function accordian(company) {
        setShow({ ...show, val: company, flag: (!show.flag) })
    }

    function messagebox(msg) {
        setdetails({ ...details, data: msg, flag_msg: (!details.flag_msg) })
        
    }

    const ondownload = () => {
        // using Java Script method to get PDF file
        fetch('Vaseem_React developer.pdf').then(response => {
            response.blob().then(blob => {
                // Creating new object of PDF file
                const fileURL = window.URL.createObjectURL(blob);
                // Setting various property values
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = 'Vaseem_React developer.pdf';
                alink.click();
            })
        })
    }

    useEffect(() =>{
        const timer = setTimeout(() =>{
            setblink(!blink);
        }, 1000);
        return()=>clearTimeout(timer);
    }, [blink]);

    return (

    
    
        <div className="main">

            <div className="left">
                <div className="sidebar">
                    <div className="sidebarheading">
                        <p>WEB RESUME</p>
                    </div>

                    <div className="sidebarlist">
                        <ul>
                            <li><a onClick={() => messagebox("Projects")}><FaSuitcase id="icon" />Projects</a></li>
                            {details.data === "Projects" && details.flag_msg === true && <div className="mydetails"><BiLeftArrow id="icon" /> 
                            <spam id="bullet">•</spam> <p className="contright">Audit Information Management (AIM) 
                            </p>
                            <spam id="bullet">•</spam> <p className="contright">Documentation Library </p>
                            <spam id="bullet">•</spam> <p className="contright">Automatic sprinkler controller </p>
                            </div>}

                            <li><a onClick={() => messagebox("Education")}><GiAchievement id="icon" />Education</a></li>
                            {details.data === "Education" && details.flag_msg === true && <div className="mydetails"><BiLeftArrow id="icon" /> 
                            <spam id="bullet">•</spam> <p className="contright">React JS Certification, Edureka Institute
                            <br></br> 
                            Year-2022, Percentage-66.20%</p>

                            <spam id="bullet">•</spam> <p className="contright">Graduation – BSC Electronics, Fergusson College
                            <br></br> 
                            Branch – Electronics Science, Percentage – 64%</p>

                            <spam id="bullet">•</spam> <p className="contright">12th Standard, J.S.S College, Gokak, INDIA
                            <br></br> 
                            Branch - Science, Percentage – 67.67%</p>

                            <spam id="bullet">•</spam> <p className="contright">10th Standard, Mayur School, Gokak, INDIA
                            <br></br> 
                            Percentage – 68.16%</p>

                            </div>}

                            <li><a onClick={() => messagebox("Personal Details")}><BsPersonLinesFill id="icon" />Personal Details</a></li>
                            {details.data === "Personal Details" && details.flag_msg === true && <div className="mydetails"><BiLeftArrow id="icon" /> 
                            {/*<spam id="bullet">•</spam> <p className="contright">Date of Birth: 2nd July 1986</p>*/}
                            <spam id="bullet">•</spam> <p className="contright">Languages known: English, Hindi, Urdu, Marathi, Kannada</p>
                            <spam id="bullet">•</spam> <p className="contright">Marital Status: Married</p>
                            <spam id="bullet">•</spam> <p className="contright">Hobbies: Reading Philosophical books and Riding bike</p>
                            </div>}

                            <li><a onClick={() => messagebox("Contact")}><MdContactPhone id="icon" />Contact</a></li>
                            {details.data === "Contact" && details.flag_msg === true && <div className="mydetails"><BiLeftArrow id="icon" /> 
                            <spam id="bullet">•</spam> <p className="contright">Mobile No.: +91 9765313661</p>
                            <spam id="bullet">•</spam> <p className="contright">Email: mvaseemraza@gmail.com</p>
                            <spam id="bullet">•</spam> <p className="contright">Address: Flat No.: C-604, Dynamic Linea<br></br>
                            Handewadi Road, Satav Nagar<br></br> 
                            Hadapsar, Pune - 411028<br></br>
                            India</p>
                            </div>}
                        </ul>
                    </div>
                    
                    <div className="download" onClick={ondownload} >
                    <GiCloudDownload id="icondownload" /><p> Download</p>
                    </div>
                </div>

                <div class="modelPic" >
                    <img src={model} alt="Logo"></img>
                    <div className="namelocation">
                    <h2 className="namefont">Vaseem Raza</h2>
                    <h3 className="namedesign">Web Developer / Technical writer</h3>
                    </div>
                </div>

            </div>
            <div className="right">
                <div className="container">
                    <h1 className="head">About me</h1>
                    <p className="designation">Web/Frontend Developer/Technical writer</p>
                    <p className="aboutme">I am Web developer with 8 years of experience in Software industry. Seeking Full-Time position in the field of React Development and looking forward to work in a challenging environment, demanding all my skills and efforts. I love to adapt myself in different fields and realize my potential, where I can get the opportunity for continuous learning and explore my creativity.</p>

                    <hr className="hline" />

                    <h1 className="experience">My experience</h1>

                    <div className="expcontainer">
                        <div className="comp" onClick={() => accordian("hcl")}>

                            
                                {blink === true && <GiBarbedStar className="myicon" id="blinkicon" />}
                                {blink === false && <GiBarbedStar className="myicon" />}

                            <div className="compleft">
                                <h3>HCL Tech</h3>
                                <p>Technical Lead</p>
                                <br></br>
                                <IoIosArrowDown className="dropdown" />
                            </div>
                            <h4 className="compright">May2022-<br></br>Working</h4>
                        </div>

                        {show.val === "hcl" && show.flag === true && <div className="compdetails">
                            <spam id="bullet">•</spam> <p className="contright">Building new React components as per the requirements received from client </p>
                            <spam id="bullet">•</spam> <p className="contright">Make changes to the existing React component as per the requirement received </p>
                            <spam id="bullet">•</spam> <p className="contright">Attend daily scrum meetings </p>
                        </div>}

                        <div className="comp" onClick={() => accordian("knovaone")}>
                            <GiBarbedStar className="myicon" />
                            <div className="compleft">
                                <h3>KNOVAONE</h3>
                                <p>Web Developer/ </p>
                                <p>Tech Writer</p>
                                <IoIosArrowDown className="dropdown" />
                            </div>
                            <h4 className="compright">May2019-<br></br>Dec2021</h4>
                        </div>
                        {show.val === "knovaone" && show.flag === true && <div className="compdetails">
                           <spam id="bullet">•</spam> <p className="contright">Interacting with stakeholders (U.S clients), noting down their project requirements and creating presentations for their approvals.</p>
                           <spam id="bullet">•</spam> <p className="contright">Taking care of front end team and guiding them with the requirement.</p>
                           <spam id="bullet">•</spam> <p className="contright">Analyze the business requirements, prepare, and review required documents Such as BRD (Business Requirements Document) and SRS (Software Requirement Document).</p>
                           <spam id="bullet">•</spam> <p className="contright">Updating Web help pages as per the enhancement.</p>
                           <spam id="bullet">•</spam> <p className="contright">Strong understanding of Business Analysis concepts, SDLC methodologies and operating models – Agile (Scrum)and Waterfall.</p>
                           <spam id="bullet">•</spam> <p className="contright">Organize meetings with developers and explain them their tasks and update the Sprint planning sheet.</p>
                           <spam id="bullet">•</spam> <p className="contright">Giving daily updates to client about project development and draft MOM after every meet.</p>
                           <spam id="bullet">•</spam> <p className="contright">Writing unit test cases and testing manually.</p>
                           <spam id="bullet">•</spam> <p className="contright">Work with testing team and make sure all modules are working as per the client’s requirement before launch.</p>
                           </div>}

                        <div className="comp" onClick={() => accordian("cognizant")}>
                            <GiBarbedStar className="myicon" />
                            <div className="compleft">
                                <h3>COGNIZANT</h3>
                                <p>Subject Matter </p>
                                <p>Expert</p>
                                <IoIosArrowDown className="dropdown" />
                            </div>
                            <h4 className="compright">Jan2018-<br></br>Mar2019</h4>
                        </div>
                        {show.val === "cognizant" && show.flag === true && <div className="compdetails">
                           <spam id="bullet">•</spam> <p className="contright">Creating detailed SOPs (Standard Operating Procedures) in web library for associates who are providing backend services for Financial products like Annuities, Retail Life, Retirement services, Death Claims, Solutions, Cash Controls, Indexing and New Business.</p>
                           <spam id="bullet">•</spam> <p className="contright">Interacting with SMEs (On Shore and Off Shore), understanding there process and there processing steps, taking required screenshots (Snagit) on their computer and creating document with detailed step by step process in proper flow with highlighted screenshot wherever required.</p>
                           <spam id="bullet">•</spam> <p className="contright">Creating MOM (Minutes of Meeting) for weekly Managerial Meeting, Creating weekly PPT for reports and presentation, Flow Charts (Microsoft Visio) for managers to understand the process flow.</p>
                           <spam id="bullet">•</spam> <p className="contright">Providing Training for new hires and creating Training Material.</p>
                           <spam id="bullet">•</spam> <p className="contright">Assisting managers to create weekly reports with Pie charts and other bar graphs.</p></div>}

                        <div className="comp" onClick={() => accordian("eaton")}>
                            <GiBarbedStar className="myicon" />
                            <div className="compleft">
                                <h3>EATON</h3>
                                <p>Technical Document </p>
                                <p>Engineer</p>
                                <IoIosArrowDown className="dropdown" />
                            </div>
                            <h4 className="compright">Oct2012-<br></br>Dec2016</h4>
                        </div>
                        {show.val === "eaton" && show.flag === true && <div className="compdetails">
                            <spam id="bullet">•</spam> <p className="contright">Handle calls from stake holders to meet there requirements in the technical aspect Creating Technical user manual of Electrical & Electronic products like UPS, MCC (Motor control circuit), Automatic Transfer Switch (ATS), Adjustable Frequency Drive (AFD) for North American clients. </p>
                           <spam id="bullet">•</spam> <p className="contright">Reading drawings, reading catalog numbers for different part and preparing user manuals according to the customer’s requirement with inputs provided by Plant Engineer.</p>
                           <spam id="bullet">•</spam> <p className="contright">Create weekly report, daily productivity report & monthly productivity dashboard for North American stakeholders.</p>
                           <spam id="bullet">•</spam> <p className="contright">Providing annotated user manuals for our special customer according to their requirement and order.</p>
                           <spam id="bullet">•</spam> <p className="contright">Monthly knowledge sharing sessions and interaction with engineering team of newly launched product lines.</p>
                           <spam id="bullet">•</spam> <p className="contright">Handle calls from stake holders to meet there requirements in the technical aspect.</p>
                            </div>}
                    </div>

                </div>
            </div>
        </div>

    )
}

export default Home;